import { graphql } from '../graphql';

export const startPdfReport = graphql(`
  mutation StartPdfReport($input: StartPdfReportInput!) {
    startPdfReport(input: $input)
  }
`);
